export default __webpack_public_path__ + "static/media/pink_coolant.683cb8df.webp";